export default __webpack_public_path__ + "static/media/splash.cd8e7bea.png";